import React, { useEffect } from "react";
import Footer from "../../Components/Common/Footer";
import Header from "../../Components/Common/Header";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import Login from "../../Components/Login/Login";

function AboutUs({ isLogin, Open }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="container">
      <InnerHeader isLogin={isLogin} />
      <div className="ContactUsContainer">
        <span>
          سایت و اپلیکیشن کنتور در سال 98 و با پشتیبانی شرکت گنجینه زرین سپهر
          راه اندازی شد. هدف از راه اندازی این سایت ارائه خدمات اینترنتی و تسهیل
          امور روزمره اشخاص حقیقی و حقوقی در حوزه استعلام قبوض شرکت های خدماتی
          با توجه به حذف قبوض کاغذی بود که آنان را از مراجعه به شرکت ها و بانکها
          برای دریافت قبوض و پرداخت آنها بی نیاز می سازد ضمن اینکه با امکانات
          این سایت و اپلیکیشن مربوطه کاربران میتوانند ضمن دسترسی به آرشیو کامل
          پرداختی قبوض مختلف ، میزان مصرف آنها را هم مدیریت کنند. از ابتدای راه
          اندازی این سایت با استقبال گسترده کاربران مواجه شدیم و در حال حاضر
          روزانه تعداد زیادی قبوض مختلف توسط سامانه کنتور استعلام و پرداخت
          میگردد. همچنین بابت خدمات ارائه شده هیچگونه هزینه ای از کاربران دریافت
          نمی گردد.
        </span>
      </div>
      <Footer isLogin={isLogin} />
      {Open && <Login />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(AboutUs);
